export default __webpack_public_path__ + "static/ground-xs-c8f6e73ec22eeb9e1a59d846db3af2f3.webp";